export default function dateFromISO(input, noTime = false) {
    const d = new Date(input);

    if (noTime) {
        return d.toLocaleDateString();
    } else {
        return `${d.toLocaleDateString()} à ${d.toLocaleTimeString()}`;
    }
}
